import PageLogin from './views/login.vue'
import PageTkLogin from './views/tklogin.vue'

const routers = [
	{
        path: '/login',
        component: PageLogin,
        name: '',
        meta: {
            public: true,
            title: '登录'
        }
    },
    {
    	path: '/tklogin',
    	component:PageTkLogin,
    	name:'',
    	meta:{
    		public:true,
    		title:'登录'
    	}
    },
	{
		path: '/',
        redirect: '/base',
        meta: {
            title: '首页'
        },
        component: (resolve) => require(['./views/layout.vue'], resolve),        
        children: [   
        	{
				path: 'success',
				component: (resolve) => require(['./views/common/success.vue'],resolve),
				name: 'success',
				meta: {
		            title: '充值成功',
		            need_back: true
		        }
			},
    		{
				path: 'base',
				component: (resolve) => require(['./views/base.vue'],resolve),
				name: 'base',
				meta: {
		            title: '基础资料'
		        }
			},
			{
				path: 'renew',
				component: (resolve) => require(['./views/renew.vue'],resolve),
				name: 'renew',
				meta: {
		            title: '续费'
		        }
			},
			{
				path: 'expand',
				component: (resolve) => require(['./views/expand.vue'],resolve),
				name: 'expand',
				meta: {
		            title: '扩容'
		        }
			},
			{
				path: 'smsbuy',
				component: (resolve) => require(['./views/smsbuy.vue'],resolve),
				name: 'smsbuy',
				meta: {
		            title: '短信充值'
		        }
			},
			{
				path: 'increment',
				redirect: '/increment/index',
				component: (resolve) => require(['./views/increment.vue'],resolve),
				name: '/increment/index',
				meta: {
		            title: '增值服务'
		        },
		       	children: [
			       	{
						path: 'index',
						component: (resolve) => require(['./views/increment/index.vue'],resolve),
						name: '/increment/index',
						meta: {
				            title: '增值服务'
				        }
					},
					{
						path: 'cart',
						component: (resolve) => require(['./views/increment/cart.vue'],resolve),
						name: '/increment/cart',
						meta: {
				            title: '购物车'
				        }
					}
		       	]
			},
			{
				path:'alipaysuccess',
				component:(resolve)=>require(['./views/alipaysuccess.vue'],resolve),
				name:'alipaysuccess',
				meta:{
					title:'支付宝支付成功'
				}
			}
			
        ]
	},
	
]

export default routers;


// WEBPACK FOOTER //
// ./src/router.js